import Vue from 'vue'
import axios from 'axios'

export default {
    state: {
        retrievedData: false,
        friendChatrooms: []
    },

    actions: {
        'friendChatsModel/fetchFriendChats': function (context, data, callback) {
            axios.get('/api/friendChatRooms').then(
                (response) => {
                    context.commit('friendChatsModel/setFriendChatrooms', response.data);

                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                }
            )
        }
    },

    mutations: {
        'friendChatsModel/setFriendChatrooms': function (state, data) {
            state.retrievedData = true;
            state.friendChatrooms = data;
        },

        'friendChatsModel/clearReadMessages'(state, data){
            state.friendChatrooms.forEach(function (chatroom) {
                if (chatroom.friendChatId === data.chatId) {
                    Vue.set(chatroom, 'unreadMessages', 0);
                }
            });
        }
    }

}


// WEBPACK FOOTER //
// ./src/ChatRoom/FriendChatsModel.js